import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full border border-ink/30 bg-transparent px-4 py-3 font-mono text-sm text-ink placeholder:text-ink/35 outline-none transition-colors duration-300 focus:border-gold";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Enquiry received. We reply within one business day.");
      setForm({ name: "", email: "", company: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please email CXO1@cbfse.com directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="border-b border-line bg-[#F7EFE3]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-24 md:grid-cols-12 md:py-32">
        <div className="md:col-span-5">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink/60">
              05 — Contact
            </p>
            <h2
              className="mt-4 font-serif text-4xl tracking-tight md:text-5xl"
              data-testid="contact-headline"
            >
              Start the conversation.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-ink/70">
              Tell us where you are in the journey — exploring, designing or
              already operating — and we will bring the right playbook.
            </p>
            <div className="mt-10 space-y-4 font-mono text-xs uppercase tracking-[0.2em] text-ink/60">
              <p data-testid="contact-email">CXO1@cbfse.com</p>
              <p data-testid="contact-phone">+91 98844 90132</p>
              <p className="leading-loose" data-testid="contact-address">
                235, Binnamangala, 2nd Floor,
                <br />
                13th Cross Road, Indira Nagar 2nd Stage,
                <br />
                Bengaluru — 560038
              </p>
            </div>
          </Reveal>
        </div>
        <div className="md:col-span-7">
          <Reveal delay={0.15}>
            <form
              onSubmit={submit}
              className="grid grid-cols-1 gap-6 border border-ink/20 bg-paper p-8 md:grid-cols-2 md:p-10"
              data-testid="contact-form"
            >
              <div>
                <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">
                  Name *
                </label>
                <input required value={form.name} onChange={set("name")} className={inputCls} placeholder="Asha Verma" data-testid="contact-name-input" />
              </div>
              <div>
                <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">
                  Work email *
                </label>
                <input required type="email" value={form.email} onChange={set("email")} className={inputCls} placeholder="asha@company.com" data-testid="contact-email-input" />
              </div>
              <div className="md:col-span-2">
                <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">
                  Company
                </label>
                <input value={form.company} onChange={set("company")} className={inputCls} placeholder="Company Ltd." data-testid="contact-company-input" />
              </div>
              <div className="md:col-span-2">
                <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">
                  What are you exploring? *
                </label>
                <textarea required rows={5} value={form.message} onChange={set("message")} className={inputCls} placeholder="We are evaluating a 50-person GCC in Bengaluru…" data-testid="contact-message-input" />
              </div>
              <div className="md:col-span-2">
                <button
                  type="submit"
                  disabled={sending}
                  data-testid="contact-submit-button"
                  className="flex items-center gap-3 border border-ink bg-transparent px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-ink hover:text-paper disabled:opacity-50"
                >
                  {sending ? "Sending…" : "Send enquiry"}
                  <ArrowRight className="h-4 w-4" />
                </button>
              </div>
            </form>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
